module.exports = __webpack_public_path__ + "static/media/cross.27e7c55d.svg";